// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1pTnD","error":"Textarea_error__2TIw0","readonly":"Textarea_readonly__Gf-dO","disabled":"Textarea_disabled__1uK3-"};